<template>
  <div class="registers">
    <div class="registers__search">
      <md-field>
        <md-icon class="icon-search"></md-icon>
        <label>Buscar</label>
        <md-input v-model="search"></md-input>
      </md-field>
    </div>
    <template v-if="!!listado.length">
      <div class="registers__head">
        <div class="registers__head-names">Apellidos y Nombres</div>
        <div class="registers__head-dni">Documento</div>
        <div class="registers__head-state">Estado</div>
      </div>

      <div class="registers__body">
        <TRow
          v-for="(item, index) in listado"
          :key="index"
          :data="item"
          @setCurrentTRegister="setCurrentTRegister"
          @deleteTRegister="deleteEmployee"
        />
      </div>
    </template>
    <div class="nodata-content" v-else>
      <img src="../../assets/img/no_data.svg" alt />
      <h5>No hay datos disponibles</h5>
    </div>

    <TRegister
      v-if="showTRegister"
      :currentData="currentTRegister"
      @close-modal="closeTregister"
      :origin="status"
      :details="detail"
    />

    <md-dialog
      v-if="showDeleteEmployee"
      :md-active.sync="showDeleteEmployee"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title>Baja de Empleado</md-dialog-title>

      <md-field>
        <label>Fecha de Fin</label>
        <v-date-picker
          v-model="dateEnd"
          class="datepick"
          popover-visibility="focus"
        >
          <md-input
            slot-scope="{ inputValue }"
            style="text-align:left !important"
            :value="inputValue"
            readonly
            required
          ></md-input>
        </v-date-picker>
      </md-field>
      <md-field>
        <label>Empleado</label>
        <md-input
          :value="
            `${currentTRegister.firstName} ${currentTRegister.firstSurname} ${
              currentTRegister.secondSurname
            }`
          "
          disabled
        />
      </md-field>

      <md-field>
        <label>Motivo de Baja</label>
        <md-select v-model="bajaMotivo" required>
          <md-option value="01">Renuncia</md-option>
          <md-option value="03">Despido</md-option>
          <md-option value="05">Jubilación</md-option>
          <md-option value="06">Invalidez permanente</md-option>
          <md-option value="07">Fin de Contrato</md-option>
          <md-option value="08">Mutuo disenso</md-option>
          <md-option value="09">Fallecimiento</md-option>
        </md-select>
      </md-field>

      <md-dialog-actions>
        <md-button class="md-accent" @click="showDeleteEmployee = false"
          >Cancelar</md-button
        >
        <md-button class="md-primary" @click="removeEmployee"
          >Dar de Baja</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <paginate
      v-model="page"
      :pageCount="pages"
      :prev-text="'p'"
      :next-text="'q'"
      :containerClass="'pagination'"
      :page-class="'page-item'"
      :clickHandler="clickCallback"
    ></paginate>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EventBus from "@/eventBus";
import TRow from "@/components/TRegisters/TRow";
import Paginate from "vuejs-paginate";

export default {
  components: {
    TRow,
    Paginate,
    TRegister: () => import("@/components/TRegister"),
  },
  name: "HasEmployee",
  created() {
    console.log("hi hi");
    this.$emit("loading-status", true)
    this.getTRegisters({
      id: this.$localStorage.get("businessID"),
      state: "hasemployee",
      page: 1,
    }).then((r) => {
      console.log(r);
      if (r.status == 200) {
        this.pages = r.data.totalPages;
        this.$emit("loading-status", false)
        EventBus.$emit("stateView", "hasemployee");
      }
    });
  },

  data() {
    return {
      search: null,
      page: 1,
      pages: 1,
      showTRegister: false,
      currentTRegister: null,
      showDeleteEmployee: false,
      status: "hasemployee",
      dateEnd: new Date(),
      bajaMotivo: null,
      detail: {}
    };
  },

  computed: {
    ...mapGetters({
      listado: "listHasEmployeeTRegister",
    }),
  },

  methods: {
    ...mapActions({
      getTRegisters: "getTRegisters",
      getTRegister: "getTRegister",
      setCurrentTRegister: "setCurrentTRegister",
      downTR: "downTR",
    }),

    async setCurrentTRegister(item) {
      this.currentTRegister = item;
      let {data, status} = await this.getTRegister(item)
      console.log(data, status)
      if(status == 200){
        this.detail = data
        this.showTRegister = true;
      }
    },

    deleteEmployee(item) {
      console.log("eliminar empleado?");
      this.currentTRegister = item;
      this.showDeleteEmployee = true;
    },

    removeEmployee() {
      console.log("gaaaa");
      // this.downTR({
      //   id: this.currentTRegister.id,
      //   body: {
      //     date: this.dateEnd.toISOString(),
      //     detail: this.bajaMotivo,
      //   },
      // }).then((r) => {
      //   if (r.status == 200) {
      //     (this.showDeleteEmployee = false), (this.currentTRegister = null);

      //     this.$toasted.success("Empleado dado de baja", {
      //       theme: "bubble",
      //       position: "top-left",
      //       duration: 1000,
      //       className: "short-message",
      //     });

      //     this.getTRegisters({
      //       id: this.$localStorage.get("businessID"),
      //       state: "hasemployee",
      //       page: 1,
      //     }).then((r) => {
      //       console.log(r);
      //       if (r.status == 200) {
      //         this.pages = r.data.totalPages;
      //         this.page = 1;
      //       }
      //     });
      //   }
      // });
    },
    closeTregister() {
      console.log("aqui debe cerrar el modal del tregistro");
      this.showTRegister = false;
    },
    clickCallback: function(page) {
      console.log(page);
      this.getTRegisters({
        id: this.$localStorage.get("businessID"),
        state: "hasemployee",
        page: page,
      });
    },
  },
  watch: {
    search: function(n, o) {
      this.$emit("loading-status", true)
      this.getTRegisters({
        id: this.$localStorage.get("businessID"),
        state: "hasemployee",
        search: this.search,
        page: 1,
      }).then((r) => {
        console.log(r);
        if (r.status == 200) {
          this.pages = r.data.totalPages;
          this.$emit("loading-status", false)
          EventBus.$emit("stateView", "hasemployee");
        }
      });
    },
  },
};
</script>

<style lang="scss">
.pagination {
  display: flex;
  justify-content: flex-end;
  li:nth-child(1) {
    font-family: "bluebox";
    font-size: 1.5rem;
    width: 2rem;
    height: 2rem;
    border-radius: 0.3rem;
    border: 1px solid #e8e9ec;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0.1rem;
    a {
      color: #808495;
      text-decoration: none;
    }
  }
  li:nth-last-child(1) {
    font-family: "bluebox";
    font-size: 1.5rem;
    width: 2rem;
    height: 2rem;
    border-radius: 0.3rem;
    border: 1px solid #e8e9ec;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0.1rem;
    a {
      color: #808495;
      text-decoration: none;
    }
  }
}

// .page-item {
//   width: 2rem;
//   height: 2rem;
//   border-radius: 0.3rem;
//   border: 1px solid #e8e9ec;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   margin: 0 0.1rem;
//   transition: all 0.3 ease-in-out;
//   background-color: white;
//   a {
//     color: #4d4f5c !important;
//   }
//   &.active {
//     border: 1px solid #3b86ff;
//     background-color: #3b86ff;
//     a {
//       color: white !important;
//     }
//   }
// }
</style>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//2-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}

//7-TRUMPS
//vue-material
.md-field {
  width: 18rem;

  &.md-theme-default {
    label {
      color: rgba($b-blue, 0.6);
      &::after {
        color: $b-orange;
      }
    }
    &::after {
      background-color: #d7dae2;
    }
    &::before {
      background-color: $b-blue;
    }
    &.md-focused {
      label {
        color: $b-blue-dark;
      }
    }

    &.md-invalid {
      label {
        color: $b-orange;
      }
      &::after {
        background-color: $b-orange;
      }
      .md-error {
        color: $b-orange;
      }
    }
  }
}

.md-dialog {
  z-index: 900;
  padding: 1rem 3rem;
  // max-width: 30rem;
  @include mq($sm) {
    height: 30rem;
    max-height: 46rem;
  }
}

.datepick {
  border-bottom: 1px solid #d7dae2;
  &__input {
    font-size: 16px;
    color: rgba(#000, 0.87);
    &::placeholder {
      color: rgba($b-blue, 0.6);
    }
  }
  input[type="text"] {
    font-size: 16px;
    color: rgba(#000, 0.87);
    &::placeholder {
      color: rgba($b-blue, 0.6);
    }
  }
}

.md-dialog-title {
  padding-left: 0;
}

.registers {
  &__search {
    display: flex;
    justify-content: center;
    @include mq($lg) {
      justify-content: flex-end;
    }
  }
  &__head {
    display: none;
    @include mq($lg) {
      display: flex;
      margin-left: calc(9px + 5.3rem);
      width: 89%;
      font-weight: 600;
      font-size: 1.1rem;
      margin-bottom: 1.5rem;
      &-names {
        width: 45%;
      }
      &-dni {
        width: 21%;
      }
    }
  }
  &__body {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
}
.nodata-content {
  padding: 2rem;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  img {
    width: 300px;
    margin: 0 auto;
  }
  h5 {
    color: $b-emph;
    margin: 2rem auto;
    font-size: 24px;
  }
}
</style>
